import React from 'react';

function Card({ title, children }) {
  return (
    <section className="app-card">
      {title ? <header className="app-card-header">{title}</header> : null}
      <div className="app-card-body">{children}</div>
    </section>
  );
}

export default Card;
